<template>
  <CommonEstimateDetail :basic-info="basicInfo" history-insert-type="design" />
</template>

<script>
import CommonEstimateDetail from '@/components/estimate-detail/index.vue'

export default {
  name: 'EstimateDetail',
  components: { CommonEstimateDetail },
  props: {
    basicInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 刷新公共估算详情
    init() {
      this.$children[0]?.init()
    }
  }
}
</script>
